import {combineReducers} from 'redux';
import flightsReducer from './flights';
import dcsReducer from './dcs'
import InventoryReducer from "./inventoryUpdater";
// import flightOpsReducer from './flightOps'
import adminReducer from './admin';
import paxSearchReducer from './paxSearch';
import authReducer from './auth';
import profileReducer from './profile';

export default combineReducers({
  inventory: InventoryReducer,
  flights: flightsReducer,
  dcs: dcsReducer,
  admin: adminReducer,
  paxSearch: paxSearchReducer,
  auth: authReducer,
  profile: profileReducer
})